import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./screens/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

async function startApp() {
    await msalInstance.initialize(); // 🔥 ESSENCIAL

    await msalInstance.handleRedirectPromise(); // trata retorno do login

    ReactDOM.createRoot(document.getElementById("root")).render(
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    );
}

startApp();